import React from 'react';
import gql from 'graphql-tag';
import {Query} from '@apollo/react-components';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import SystemDetailsPage from './SystemDetailsPage';
import ErrorPage from '../ErrorPage';

const GET_SYSTEM_DETAILS = gql`
  query System($id: ID!) {
    system(id: $id) {
      id
      type
      hpu
      gangway
      addOns
      area
      softwareVersion
      aepEnable
      eepEnable
      gxl
      gxxl
      hexapodOrientation
      hoist
      oneOperator
      pinocchioTip
      pinPushers
      slewingEncoder
      tipHeaveCompensation
      boxPC
      angularBoomTip
      location {
        timezone
        longitude
        latitude
      }
      project {
        code
        owner {
          name
        }
        vessel
        client {
          company
          email
          phone
        }
      }
      # to do location
    }
  }
`;

class SystemDetails extends React.Component {

  state = {};

  static getDerivedStateFromError(error) {
    return {error};
  }

  render() {
    const {match: {params: {id}}} = this.props;
    const {error: reactError} = this.state;
    return (
      <Query query={GET_SYSTEM_DETAILS} variables={{id}}>
        {({loading, error, data}) => {
          if (error || reactError) {
            return <ErrorPage error={error || reactError} />;
          }
          return <SystemDetailsPage system={data ? data.system : {}} loading={loading}/>;
        }}
      </Query>
    );
  }
}

SystemDetails.propTypes = {
  match: PropTypes.object
};

export default withRouter(SystemDetails);

